// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3574) return "static/chunks/3574-5f6d40f9a55a457f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","2662":"b9b26c3f","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"865e1bd07ad57be4","1368":"1e1403a599808998","1958":"7d0cabe3685900a0","2662":"3b737e5cccfa0b42","3197":"69f4b08e9aa95c8e","3321":"442566274f796504","7378":"e7af93239e7edeb7","9777":"c735bf2414ca04db"}[chunkId] + ".js";
};